import { defineStore } from 'pinia';
import OnixFlowsAPI from 'dashboard/api/onix/flows';
import { throwErrorMessage } from 'dashboard/store/utils/api';

export const useOnixFlowsStore = defineStore('onixFlows', {
  state: () => ({
    records: [],
    currentFlow: null,
    uiFlags: {
      fetchingList: false,
      fetchingItem: false,
      creatingItem: false,
      updatingItem: false,
      deletingItem: false,
    },
  }),

  getters: {
    getFlows: state => state.records,
    getCurrentFlow: state => state.currentFlow,
    getUIFlags: state => state.uiFlags,
  },

  actions: {
    setUIFlag(data) {
      this.uiFlags = { ...this.uiFlags, ...data };
    },

    async fetch() {
      this.setUIFlag({ fetchingList: true });
      try {
        const { data } = await OnixFlowsAPI.get();
        this.records = data.payload || [];
      } catch (error) {
        throwErrorMessage(error);
      } finally {
        this.setUIFlag({ fetchingList: false });
      }
    },

    async show(id) {
      this.setUIFlag({ fetchingItem: true });
      try {
        const { data } = await OnixFlowsAPI.show(id);
        this.currentFlow = data;
        return data;
      } catch (error) {
        throwErrorMessage(error);
        return null;
      } finally {
        this.setUIFlag({ fetchingItem: false });
      }
    },

    async create(payload) {
      this.setUIFlag({ creatingItem: true });
      try {
        const { data } = await OnixFlowsAPI.create(payload);
        this.records = [data, ...this.records];
        this.currentFlow = data;
        return data;
      } catch (error) {
        throwErrorMessage(error);
        return null;
      } finally {
        this.setUIFlag({ creatingItem: false });
      }
    },

    async update(id, payload) {
      this.setUIFlag({ updatingItem: true });
      try {
        const { data } = await OnixFlowsAPI.update(id, payload);
        this.currentFlow = data;
        this.records = this.records.map(f => (f.id === data.id ? data : f));
        return data;
      } catch (error) {
        throwErrorMessage(error);
        return null;
      } finally {
        this.setUIFlag({ updatingItem: false });
      }
    },

    async delete(id) {
      this.setUIFlag({ deletingItem: true });
      try {
        await OnixFlowsAPI.delete(id);
        this.records = this.records.filter(f => f.id !== Number(id));
        if (this.currentFlow?.id === Number(id)) this.currentFlow = null;
      } catch (error) {
        throwErrorMessage(error);
      } finally {
        this.setUIFlag({ deletingItem: false });
      }
    },
  },
});
